import React, { useState, useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  CardActions,
  Button,
  TextField,
  Grid,
  CircularProgress,
} from "@material-ui/core";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import SubjectIcon from "@material-ui/icons/Subject";
import serviciosTablero from "utils/serviciosTablero";
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";

const Descripcion = ({ tarjeta, setCargando, setMensaje }) => {
  const classesTablero = useStylesTablero();
  const [descripcion, setDescripcion] = useState("");
  const [descripcionTemp, setDescripcionTemp] = useState("");
  const [editMode, setEditMode] = useState(false); // Estado para el modo de edición
  const [error, setError] = useState(""); // Estado para errores
  const titleStyle = {
    display: "flex",
    alignItems: "center",
  };
  const getDescripcion = () => {
    serviciosTablero.getDescripcion(
      (status, mensaje, data) => {
        if (status === 1) {
          setDescripcion(data.descripcion || ""); // Si no hay descripción, dejarlo vacío
          setDescripcionTemp(data.descripcion || "");
        } else {
          console.error("Error al obtener la descripción:", mensaje);
        }
      },
      setCargando,
      { idtarjeta: tarjeta }
    );
  };
  useEffect(() => {
    getDescripcion();
  }, [tarjeta]);
  const handleGuardarDescripcion = () => {
    
    if (!descripcionTemp.trim()) {
      setError("La descripción no puede estar vacía.");
      return;
    }
    setError("");
    const datosDescripcion = {
      descripcion: descripcionTemp,
      idtarjeta: tarjeta,
    };

    serviciosTablero.addDescripcion(
      (status, mensaje, data) => {
        if (status === 1) {
          setEditMode(false); // Salir del modo de edición
          setMensaje({ open: true, status: status, value: mensaje });
          setDescripcion(data?.descripcion)
          setDescripcionTemp(data?.descripcion)
        } else {
          setMensaje({
            open: true,
            status: -1,
            value: "Hubo un problema al guardar la descripción.",
          });
          setEditMode(false);
        }
      },
      setCargando,
      datosDescripcion
    );
  };

  const handleCancelarDescripcion = () => {
    setDescripcionTemp(descripcion);
    setEditMode(false);
  };

  return (
    <Box>
      <Box sx={titleStyle}>
        <SubjectIcon sx={{ marginRight: 1 }} style={{ color: "#CCCCCC" }} />
        <Typography variant="h6" component="h2" style={{ color: "#CCCCCC" }}>
          Descripción
        </Typography>
      </Box>
      {editMode ? (
        <TextField
          fullWidth
          variant="outlined"
          label="Descripción"
          multiline
          value={descripcionTemp}
          onChange={(e) => setDescripcionTemp(e.target.value)}
          rows={4}
          style={{
            backgroundColor: "#45505A",
            border: "none",
            borderRadius: "1px",
          }}
          className={classesTablero.field}
          error={!!error}
          helperText={error}
        />
      ) : (
        <Typography
          style={{
            backgroundColor: "#45505A",
            padding: "8px",
            borderRadius: "1px",
            cursor: "pointer",
            borderColor: "#CCCCCC",
            border: "solid 1px",
            whiteSpace: 'pre-line'
          }}
          onDoubleClick={() => setEditMode(true)}
        >
          {descripcion || "Haz doble clic para agregar una descripción"}
        </Typography>
      )}
      <br />
      {editMode && (
        <>
          <Button
            variant="contained"
            color="primary"
            onClick={handleGuardarDescripcion}
            style={{ margin: "10px 5px 10px" }}
            className={classesTablero.btnAceptar}
            size="small"
          >
            {"Guardar Descripción"}
          </Button>
          {descripcionTemp && (
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleCancelarDescripcion}
              style={{ margin: "10px 5px 10px" }}
              className={classesTablero.btnCancelar}
              size="small"
            >
              {"Cancelar"}
            </Button>
          )}
        </>
      )}
    </Box>
  );
};

export default Descripcion;
